// inputs :
// 1. color Hexa
// 2. percentage : < 0 : darken, > 0 : lighten
// output : Hexa color (darken/ligthen) by (percent)%
export default function LightenDarkenColor(color?:string, percent?:number) {
    if(color && percent){
        var num = parseInt(color.replace("#",""), 16),
            amt = Math.round(2.55 * percent),
            R = (num >> 16) + amt,
            B = ((num >> 8) & 0x00FF) + amt,
            G = (num & 0x0000FF) + amt;
        return '#'+(0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
    }
};

export function colorToShades(hex: string, count: number): string[] {
  const shades: string[] = [];
  const base = hex.replace("#", "");
  const r = parseInt(base.substring(0, 2), 16);
  const g = parseInt(base.substring(2, 4), 16);
  const b = parseInt(base.substring(4, 6), 16);

  // Répartition : 75% clair, 25% foncé
  const lightCount = Math.round(count * 0.75);
  const darkCount = count - lightCount - 1; // -1 pour la couleur d'origine

  const maxLightFactor = 1.4; // éclaircir +40%
  const maxDarkFactor = 0.85; // foncer -15%

  // Nuances plus claires (du plus clair à la couleur originale)
  for (let i = lightCount; i > 0; i--) {
    const factor = 1 + ((maxLightFactor - 1) * i) / lightCount;
    shades.push(rgbToHex(r * factor, g * factor, b * factor));
  }

  // Couleur originale
  shades.push(hex);

  // Nuances plus foncées (de la couleur originale au plus foncé)
  for (let i = 1; i <= darkCount; i++) {
    const factor = 1 - ((1 - maxDarkFactor) * i) / darkCount;
    shades.push(rgbToHex(r * factor, g * factor, b * factor));
  }

  return shades;
}

function rgbToHex(r: number, g: number, b: number): string {
  return (
    "#" +
    Math.min(255, Math.max(0, Math.round(r))).toString(16).padStart(2, "0") +
    Math.min(255, Math.max(0, Math.round(g))).toString(16).padStart(2, "0") +
    Math.min(255, Math.max(0, Math.round(b))).toString(16).padStart(2, "0")
  );
}
